export default __webpack_public_path__ + "static/media/img-company-main.f111061c.png";